import React from 'react';

const PrivacyPolicyEN = () => {
  return (
    <>
      ‘Vlending’(Hereinafter referred to as &quot;Company&quot;) values user’s online privacy, and is committed to
      protect the user’s personal information provided to the Company during the use of the Company’s mobile service
      ‘Mubeat’ (Hereinafter referred to as &quot;Service&quot;).
      <br />
      <br />
      This Privacy Policy may be changed from time to time due to changes in government laws and guidelines or changes
      in Vlending&apos;s internal policy. In cases where there are changes to the contents of this Privacy Policy,
      Vlending will promptly reflect the changes in the Privacy Policy found in the APP Service &gt; Settings, and on
      the initial page of the Homepage.
      <br />
      <br />
      <b>1. Collection of Information</b>
      <br />
      The Company requires certain information to provide the Service to the users (Hereinafter referred to as
      &quot;Member&quot;).
      <br />
      Members do not have to create an account to use some of the Service features, such as searching, viewing the
      charts or artist’s channel. If a Member chooses to register and create an account, he or she must provide the
      Company with some personal data so that the Company can provide the Service. When creating an account, a Member
      can sign up or connect to the Service with an account from another service like Google, Facebook or Twitter.
      <br />
      In addition, in order to provide the Member with convenient and various services, the Company can use the personal
      information collected from the Member to carry out advertising or marketing activities of the services provided by
      the Company through methods like E-mail or push notifications. In such cases, the Member can refuse unwanted
      services any time through E-mail, etc.
      <br />
      <br />
      <b>1.1 Method of Collection</b>
      <br />
      By selecting and clicking the &quot;Agree&quot; button for the Company&apos;s Terms of Service at the time of
      signing up, the Member agrees to this Privacy Policy, and accordingly, the Company collects personal information
      based on the information entered in the registration form.
      <br />
      The Company collects the information of the Member in the following ways:
      <ul>
        <li>
          Information collected during the registration for the Service or in the course of the use of the Service
        </li>
        <li>Information provided by the third parties and business partners of the Company</li>
        <li>Information collected during the 1:1 inquiry and information provided directly by the user</li>
      </ul>
      <b>2. What We Collect</b>
      <br />
      <br />
      <b>2.1 Basic Account Information</b>
      <br />
      For account registration, log-in service, seamless customer support, and to verify the user’s age for content use,
      the Company collects and uses the following personal information:
      <ul>
        <li>Log in via Mubeat account: user ID (E-mail address), password, age</li>
        <li>
          Log in via Facebook account (only when the user is set as a public user profile): Facebook ID, E-mail address,
          display name, age
        </li>
        <li>Log in via Google Plus account: Google Plus ID, E-mail address, display name, age</li>
        <li>Log in via Twitter account: Twitter ID, E-mail address, display name, age</li>
      </ul>
      The following information may be collected with the user’s consent for age verification or identity verification
      as required by relevant laws or regulations:
      <ul>
        <li>Encoded identification information (CI)</li>
        <li>Identification information of overlapped membership (DI)</li>
      </ul>
      In the course of using other services, the following information may be generated and collected:
      <ul>
        <li>Mubeat services related activities, such as video selection, watch history, and search terms</li>
        <li>
          Additional collection of E-mail addresses and giveaway shipping information during the processing of events
          and customer inquiries.
        </li>
      </ul>
      <b>2.2 Technical information</b>
      <br />
      To securely and reliably set up and maintain the account of Members and to operate our Service, the Company uses
      technology like application program interfaces (APIs) and embeds to make that informations available to websites,
      the application, and others to collect certain types of, but are not limited to, the information addressed below:
      <br />
      Log data:
      <br />
      The Company receives information when Members use the Service, which we refer to as &quot;Log Data,&quot; even if
      users have not created an account. This Log Data includes information such as Member’s IP address, unique device
      identifier (UUID), operating system, mobile carrier, device information (including device language settings), and
      ad identifiers (GAID/ IDFA).
      <br />
      The Company uses information the Members provide and the data provided, including log data and data from third
      parties, to make inferences like what contents the Members might be interested in, age, what languages they speak
      and etc. This helps us better design our Service.
      <br />
      Links:
      <br />
      To operate our Service, the Company keeps track of how Members interact with the share links of video clips from
      the Service on other websites.
      <br />
      Location information:
      <br />
      The Company may collect general information (e.g. IP address and country of residence) about the Member’s
      location, and may use that information to customize the Service and features that need to know the Member’s
      location to work properly. By accessing and using the Service, the Member consents to this collection and
      processing of location information.
      <br />
      The Company receives these information from our business partners and service providers (such as Google Analytics)
      who assist us in offering and improving the Service by providing information about how the Members use the
      Service.
      <br />
      Below are the list of, but are not limited to, the service providers of the Company:
      <ul>
        <li>Google Analytics</li>
        <li>Firebase</li>
        <li>Facebook Analytics</li>
        <li>Amazon Web Service</li>
      </ul>
      <b>3. Use of Information</b>
      <br />
      The Company may use the collected information of users for any of the following purposes:
      <ul>
        <li>To provide the Service in a seamless manner and to facilitate, manage and improve the user experience</li>
        <li>For Member identification and to detect and deter unauthorized use of or abuse of the Service</li>
        <li>To make statistics on the user’s Service usage</li>
        <li>To conduct user surveys and statistical analysis for the improvement of the Service</li>
        <li>To verify and respond to any requires made by the user</li>
        <li>
          To notify the user of any other important notifications (through push notification, E-mail, online message
          channel), if necessary
        </li>
        <li>
          To provide promotional events and advertising information (through push notification, E-mail, online message
          channel)
        </li>
        <li>To provide personalized service and information (including advertisements) provided by the Company</li>
      </ul>
      ※ The Company collects minimal behavioral data in order to transmit personalized online ad information. In order
      to provide personalized ad information, behavioral data collected through ad identifiers is stored for up to 6
      months and is then destroyed. When destroyed, a technical method is used such that recovery or restoration is
      impossible. Members can block personalized ads at any time, and if they do, they will no longer be shown
      personalized ads.
      <br />
      <br />
      <b>How to decline collection of behavioral data</b>
      <ul>
        <li>Android Phone - Google Settings → Ads → Opt out of Ads Personalization</li>
        <li>iPhone - Settings → Privacy → Advertising → Limit Ad Tracking</li>
      </ul>
      <b>4. Sharing of Information</b>
      <br />
      The Company will not share personal information to a third party without the user’s content, unless one of the
      following circumstances applies:
      <ul>
        <li>Affiliates and service providers that support the seamless provision of the Service</li>
        <li>
          With companies that perform services on the Company’s behalf (including both third parties and our
          affiliates), such as providers of technical infrastructure (such as servers) or engineering or other support,
          technical services and features developers, research and analytical companies, and E-mail providers
        </li>
        <li>When the users consent to the sharing in advance</li>
        <li>
          If required to be disclosed by the relevant laws and regulations and when we believe in good faith that such
          sharing is permitted by law or is reasonably necessary in order to investigate, prevent, or take action
          regarding possible illegal activities, suspected fraud, situations involving potential threats to the physical
          safety of any person, violations of this Privacy Policy or the Terms of Service
        </li>
        <li>
          With our affiliates for the collective benefit of our affiliates’ businesses and for operational purposes
        </li>
      </ul>
      The Company shares user data with ad technology providers. These ad technology providers may collect users&apos;
      behavioral data and use data about users for the purposes of ads personalization and measurement.
      <br />
      Below is a list of the Company&apos;s ad technology providers. The providers may vary by country:
      <ul>
        <li>Google</li>
        <li>Smart Media Representative Co., Ltd</li>
        <li>Facebook</li>
        <li>IGAWorks</li>
        <li>Tapjoy</li>
        <li>Buzzvil</li>
        <li>Vungle</li>
        <li>AppLovin</li>
        <li>PubMatic</li>
        <li>Liftoff</li>
        <li>adPOPcorn</li>
        <li>MoPub</li>
      </ul>
      <b>4.1 Public Information</b>
      <br />
      When a Member creates an account, the display name and profile image information are always public and shared with
      other Members of the Service. When a Member uploads postings in the artist community, the contents are shown to
      the public. Any comments posted on another Member’s postings will also be public. The Member is responsible for
      all the information they provide through the Service, and so should think carefully about what he or she makes
      public, especially if it is sensitive information.
      <br />
      <br />
      <b>5. Personal Data of Children</b>
      <ol>
        <li>
          The Company does not knowingly collect or solicit personal data from anyone under the age of 16 in countries
          that implement the EU GDPR amendment. If you are under the required minimum age, please do not attempt to
          register for the Service or send any Personal Data about yourself to the Company. If we learn that we have
          collected Personal Data from a child under the required minimum age, we will delete that information as
          quickly as possible. If you believe that a child under the required minimum age may have provided us Personal
          Data, please contact us at support@mubeat.tv.
        </li>
        <li>
          According to each country&apos;s law, it may lower the age limit for children requiring the consent of their
          legal representatives, such as parents, down till the age of 13. For children under 13 years old, they can do
          so through their legal representative or authorized representative. In this case, the legal representative has
          all the rights of the Member. A Member under 16 or where applicable should only sign up after fully
          understanding the purpose of the collection and use of personal information and after obtaining the consent of
          a legal representative or parents. In addition, legal representatives, such as parents, may request to view,
          correct or renew the personal information of children, or withdraw their consent for membership, and in such
          cases, the Company shall take necessary measures without any delays.
        </li>
      </ol>
      If you believe that a child under the required minimum age who needs parental guidance is providing personal
      information, please contact support@mubeat.tv.
      <br />
      <br />
      <b>6. User’s Rights to Access and Control</b>
      <br />
      The user may exercise his/her right to access or modify the registered personal information, or request to delete
      the user account.Through the account settings, a Member may access, edit or in some cases delete the following
      information that he or she has provided to the Company:
      <ul>
        <li>Display name and password</li>
        <li>E-mail address</li>
        <li>Profile image</li>
        <li>Community and wall postings, including text, images and links that Members have uploaded on the Service</li>
      </ul>
      Users who wish to correct or delete the above information or other data, please send the following information to
      support@mubeat.tv.
      <ul>
        <li>Mubeat Email address and ID</li>
        <li>Detailed information regarding the request</li>
      </ul>
      The information Members can view, update, and delete may change as the Service changes.
      <br />
      When the user requests the errors in personal information to be rectified, the personal information will not be
      used or provided before the rectification is completed.
      <br />
      The Company manages the deactivated or deleted personal information as set out under the ‘Period of Use of
      Personal Information’ section below, and such personal information is not viewable or used for any other purposes.
      <br />
      <br />
      <b>7. Period of Use of Personal Information</b>
      <br />
      The Company retains personal information for up to 30 days.
      <br />
      According to the circumstances, the Company may keep Log data for up to 18 months in cases where storage
      obligations are specified, or is within the Company’s internal policy, or is with the consent of the user, or is
      in the period of retention notified in advance, or in cases of litigation or disputes or the possibility of such
      actions. When a Member closes his or her account, the Company may keep their personal information in cases where
      it is needed for legal responses and such, for as long as necessary.
      <br />
      However, during this period the Company may only use the information for the relevant purposes. If the Company
      needs to keep the information after this period, the Company will notify the user and obtain the individual
      consent.
      <br />
      For personal information that is provided for disclosed temporary purposes(events, surveys, etc.), after the
      purpose has been fulfilled, that personal information will be, according to the Member&apos;s intention, processed
      as information necessary for membership registration or deleted completely from the disk in a way that cannot be
      read or used.
      <br />
      <br />
      <b>8. Personal Information Destruction Procedure and Method</b>
      <br />
      The following is the Company’s procedure and method of personal information destruction.
      <br />
      <br />
      <b>8.1 Destruction Procedure</b>
      <br />
      After fulfilling the purposes of collection outlined in this Privacy Policy, user’s personal information is stored
      as stated in ‘7. Period of Use of Personal Information’, and then destroyed according to internal policies and
      relevant laws. Such personal information will not be used for purposes other than retention except when required
      by law.
      <br />
      <br />
      <b>8.2 Destruction Method</b>
      <br />
      Paper records will be shredded by a shredder and electronic records will be discarded in an irreversible manner
      using technical methods.
      <br />
      <br />
      <b>8.3 Notice on Personal Information of Inactive Accounts</b>
      <br />
      In accordance with the [Korea’s Information and Communication Network- Personal Information Protection Act], in
      the case of inactive users who have not used Mubeat’s service for one year, the account will be converted to
      Inactive account, and the user’s personal information will be stored separately. The company notifies users of the
      Inactive account 30 days before the expiration date, and the details of the notification are as follows.
      <ul>
        <li>
          Content of Notification: the fact that the Inactive account is scheduled to be converted, the scheduled date
          of the separate storage of personal information, and the personal information subject to be stored separately.
        </li>
        <li>Subject of Notification: Users registered with email.</li>
        <li>Method of Notification: Email.</li>
        <li>Date of Notification: 00:00 (KST), 30 days before the transition to an Inactive account.</li>
      </ul>
      <b>8.4 Restoring Inactive Accounts</b>
      <br />
      When a user with an Inactive account reuses the Mubeat service by activating the account, the personal information
      will be restored.
      <br />
      <br />
      <b>9. Assistance Regarding Personal Data</b>
      <br />
      If you have any questions/complaints/suggestions regarding this Privacy Policy or how our data practices
      generally, please contact the Company’s privacy protection division by using the following information:
      <br />
      Vlending Co., Ltd.
      <br />
      Attn: Data Protection Officer
      <br />
      11F, 343 Gangnam-daero, Seocho-gu,
      <br />
      Seoul, South Korea.
      <br />
      support@mubeat.tv
      <br />
      The Company is responsible for the handling of personal information and appoints and operates the person and
      department in charge, as mentioned below, of personal information protection and the handling of complaints and
      damages related to personal information.
      <ul>
        <li>
          Personal Information Protection Officer <br />
          Name: Changwon Son <br />
          Affiliation / Position: Vlending Chief Executive Officer / Chief Executive Officer <br />
          E-mail: info@vlending.co.kr Phone: 02-784-8562
        </li>
        <li>
          Personal Information Processing Officer <br />
          Name: Hyun Woon Ko <br />
          Affiliation / Position: Vlending Deputy Director / Deputy Director <br />
          E-mail: support@mubeat.tv Phone: 02-784-8562
        </li>
      </ul>
      All inquiries, complaints, damage relief, etc related to personal information that occurred during use, can be
      made to the person or department in charge of personal information protection. The Company will answer and process
      the user&apos;s inquiries.
      <br />
      <br />
      <b>10. Changes to the Privacy Policy</b>
      <br />
      When we make any material changes to this Privacy Policy, we will notify the user by displaying a notice within
      the Service, and the updated Privacy Policy will become effective 7 days from the day on which the notice is
      posted.
      <br />
      <br />
      Addendum.
      <br />
      The following Privacy Policy will take effect from September 30th, 2021.
    </>
  );
};

export default PrivacyPolicyEN;
